'use strict';

import { Tabs } from './tabs.js';

export class TabsMyadstabs extends Tabs {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {
		this.$items.on('click', this.option_click_handler.bind(this));
	}
	
	option_click_handler(event) {
		const $clicked_item = jQuery(event.currentTarget);
		if ($clicked_item.hasClass('active')) {
			event.preventDefault();
		}
	}
}
